import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProjectsPage from '../pages/ProjectsPage';
import ProjectDetailPage from '../pages/ProjectDetailPage';
import ProjectProposalsPage from '../pages/ProjectProposalsPage';
import ContractorProjectsPage from '../pages/ContractorProjectsPage';
import BOQTrackerPage from '../pages/BOQTrackerPage';
import { Container, Typography, CircularProgress, Button } from '@mui/material';

const ProjectsRouter = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Show loading state while authentication is being checked
  if (isLoading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>Loading...</Typography>
      </Container>
    );
  }

  // Redirect to login if not authenticated (though this should be handled by ProtectedRoute)
  if (!isAuthenticated || !user) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="error">
          Access denied. Please log in to view projects.
        </Typography>
      </Container>
    );
  }

  // Route to appropriate projects page based on user role
  const role = user.role?.toLowerCase();
  
  if (role === 'admin') {
    // Redirect admins to their admin dashboard
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Admin Access Restricted
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Use the Admin Dashboard to manage platform projects and user activities.
        </Typography>
        <Button 
          variant="contained" 
          href="/admin/dashboard"
          sx={{ mt: 2 }}
        >
          Go to Admin Dashboard
        </Button>
      </Container>
    );
  }

  if (role === 'contractor') {
    return (
      <Routes>
        <Route path="/:projectId/boq" element={<BOQTrackerPage />} />
        <Route path="/:projectId/boq/:boqId" element={<BOQTrackerPage />} />
        <Route path="/:id" element={<ContractorProjectsPage />} />
        <Route path="/" element={<ContractorProjectsPage />} />
      </Routes>
    );
  }

  // For client, verifier, quality_inspector, and default roles
  return (
    <Routes>
      <Route path="/:projectId/boq" element={<BOQTrackerPage />} />
      <Route path="/:projectId/boq/:boqId" element={<BOQTrackerPage />} />
      <Route path="/:id/proposals" element={<ProjectProposalsPage />} />
      <Route path="/:id" element={<ProjectDetailPage />} />
      <Route path="/" element={<ProjectsPage />} />
    </Routes>
  );
};

export default ProjectsRouter;
